export default {
  signIn: '登入',
  signOut: '登出',
  points: '點數',
  hyattSignInButton: '登入凱悅天地',
};
